import { createContext } from 'react'
import { RichInputOption } from '../'

export const RichInputContext = createContext<any>({})

export type RichInputProviderProps = {
    triggers: string[]
    options: RichInputOption[]
    onTrigger: (value) => void
    onWord: (value, cb, always?) => void
}

export const RichInputProvider = (props: any) => {
    const { triggers = [], options = [], onWord, onTrigger, children } = props

    return (
        <RichInputContext.Provider
            value={{
                triggers,
                options,
                onTrigger,
                onWord,
            }}>
            {children}
        </RichInputContext.Provider>
    )
}
